/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Search_Properties_PlaceholderInputs */

const cs_filter_search_properties_placeholder = /** @type {(inputs: Filter_Search_Properties_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název, adresa nebo číslo zakázky`)
};

const en_filter_search_properties_placeholder = /** @type {(inputs: Filter_Search_Properties_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title, address, or listing number`)
};

/**
* | output |
* | --- |
* | "Title, address, or listing number" |
*
* @param {Filter_Search_Properties_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_search_properties_placeholder = /** @type {((inputs?: Filter_Search_Properties_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Search_Properties_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_search_properties_placeholder(inputs)
	return cs_filter_search_properties_placeholder(inputs)
});